var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel__body pt-4 ml-4 mr-4"},[_c('Detail',{staticClass:"mb-2",attrs:{"article_id":_vm.$route.params.id,"show_berita":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }